import type { IOpenApplicationDetailsProps } from "@/modules/application/common/types";
import { ApplicationHistory } from "@/modules/application/components";
import { setApplication, setApplicationRowId } from "@/modules/application/state";
import { PageHeader } from "@/shared/components";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { useEffect, useState } from "react";

interface IDetailsOpenState {
  isAccountOpeningApplication: boolean;
}

export const ApplicationHistoryPage = () => {
  const dispatch = useAppDispatch();
  const activeTransactionId = useAppSelector((state) => state.common.transactionId);
  const [detailsOpenState, setDetailsOpenState] = useState<IDetailsOpenState>({
    isAccountOpeningApplication: false,
  });

  const onOpenDetails = ({ applicationType }: IOpenApplicationDetailsProps) => {
    const key = `is${applicationType}` as keyof IDetailsOpenState;
    if (key in detailsOpenState) {
      setDetailsOpenState((prev) => {
        const newState = {} as IDetailsOpenState;
        const stateKeys = Object.keys(prev) as (keyof IDetailsOpenState)[];
        stateKeys.forEach((k) => {
          newState[k] = k === key;
        });
        return newState;
      });
    } else {
      dispatch(setApplicationRowId(null));
      dispatch(setApplication(null));
    }
  };

  const resetDetailsState = (state: IDetailsOpenState): IDetailsOpenState => {
    return Object.keys(state).reduce((acc, key) => {
      acc[key as keyof IDetailsOpenState] = false;
      return acc;
    }, {} as IDetailsOpenState);
  };

  const onCloseDetails = () => {
    setDetailsOpenState(prev => resetDetailsState(prev));
    dispatch(setApplicationRowId(null));
    dispatch(setApplication(null));
  };

  useEffect(() => {
    if (!activeTransactionId) {
      onCloseDetails();
    }
  }, [activeTransactionId]);

  return (
    <>
      <div className="full-width page-container transaction-history-page">
        <PageHeader/>
        <ApplicationHistory openDetails={onOpenDetails}/>
      </div>
    </>
  );
};
